import * as React from 'react';
import './GroupDeletePopup.css';
import { inject, observer } from 'mobx-react';
import * as ReactGA from 'react-ga';
import GroupService from '../../../../../services/GroupService';
import { AppStore } from '../../../../../stores';

export interface IProps {
  appStore?: AppStore;
  onClose: () => void;
  onDelete: () => void;
}

export interface IState {
}

@inject('appStore')
@observer
export default class GroupDeletePopup extends React.Component<IProps, IState> {

  constructor(props, context) {
    super(props, context);
    this.state = {
    }
  }

  render() {
    return (
      <div className="groupDeletePopup">
        <div
          className="groupDeletePopupBackground"
          onClick={() => {
            this.props.appStore!.showingSignUp = false;
          }}
        />
        <div className="groupDeletePopupBox">
          <h3>{window.loc.strings.deletePopupHeadline}</h3>
          <div
            className="groupDeleteBtn"
            onClick={() => {
              this.props.onDelete();
            }}
          >
            {window.loc.strings.delete}
          </div>
          <div
            className="groupCancelBtn"
            onClick={() => this.props.onClose()}
          >
            {window.loc.strings.cancel}
          </div>
        </div>
      </div>
    );
  }

}